import React, { Component } from 'react';
import actions from '../../redux/actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import FilterView from './filter-view';
import _max from 'lodash/max';
import _flatten from 'lodash/flatten';
import _unionBy from 'lodash/unionBy';
import _orderBy from 'lodash/orderBy';
import _merge from 'lodash/merge';
import _pullAllWith from 'lodash/pullAllWith';

class SearchFilterContainer extends Component {
      constructor(props) {
            super(props);
            this.onInfoChange = this.onInfoChange.bind(this);
            this.onBudgetChange = this.onBudgetChange.bind(this);
            this.onRangeNumbersChange = this.onRangeNumbersChange.bind(this);
            this.onDropdownChange = this.onDropdownChange.bind(this);
            this.currencyFormat = this.currencyFormat.bind(this);
            this.onStarRatingChange = this.onStarRatingChange.bind(this);
            this.onOffersChange = this.onOffersChange.bind(this);
      }
      
      componentDidUpdate(prevProps){
            if (this.props.searchId !== prevProps.searchId && this.props.isFilterEmpty)
                  this.objectFilter(this.props.model);
      }

      objectFilter(model) {
            let availableHotelAmenities = [];
            let roomAmenities = [];
            let roomCategory = [];
            let boardBasis = [];

            model.forEach(result => {
                  availableHotelAmenities.push(result.hotel.amenities);
                  roomAmenities.push(...result.rates.map(r=>r.roomCategory.roomAmenities));
                  roomCategory.push(...result.rates.map(r=>r.roomCategory));
                  boardBasis.push(...result.rates.map(r=>r.ratePlan.boardBasis));
            });

            availableHotelAmenities = this.createOptionList(_flatten(availableHotelAmenities), 'id');
            roomAmenities = this.createOptionList(_flatten(roomAmenities), 'id');
            roomCategory = this.createOptionList(roomCategory, 'name');
            boardBasis = this.createOptionList(boardBasis, 'id');
            let budgetMax = this.props.maxBudget + 50;
            this.props.actions.applyFilter(
                  { 
                        budget: { min: 0, max:  budgetMax ? budgetMax : 500 }, 
                        availableHotelAmenities: availableHotelAmenities,
                        availableRoomAmenities: roomAmenities,
                        availableRoomCategory: roomCategory,
                        availableBoardBasis: boardBasis,
                        budgetMax: budgetMax,
                        starRating: new Set(),
                        info: new Set(),
                        offers: new Set(),
                        hotelAmenitiesValue:null,
                        roomAmenitiesValue:null,
                        roomCategoryValue:null,
                        boardBasisValue:null
                  }
            );
      }

      createOptionList(data, idField) {
            let output = _unionBy(data, idField);
            output = output.map((t) => {
                  return { value: t[idField], label: t.name };
            });
            output = _orderBy(output, 'label', 'asc');
            return output;
      }

      onInfoChange(elm) {
            const { searchFilter, actions } = this.props;
            let checkboxList = new Set(searchFilter.info);

            if (elm.target.checked) 
                  checkboxList.add(elm.target.name);
            else
                  checkboxList.delete(elm.target.name);

            let filterData = {...searchFilter, info:checkboxList};

            actions.applyFilter(filterData).then((data)=>{
                  const { searchData } = this.props;
                  let filterExpression = this.buildFilter(data);
                  const req = {
                        ...searchData,
                        pageNumber: 0,
                        filterExpression 
                  };

                  actions.getHotelAvailabilityXmlRequest(req);
            });
      }

      onOffersChange(elm) {
            const { searchFilter, actions } = this.props;
            let checkboxList = new Set(searchFilter.offers);

            if (elm.target.name === 'specialOffer' || checkboxList.has('specialOffer')){
                  checkboxList.clear();
            } else
                  checkboxList.delete('specialOffer');

            if (elm.target.checked) 
                  checkboxList.add(elm.target.name);
            else
                  checkboxList.delete(elm.target.name);

            let filterData = {...searchFilter, offers:checkboxList};

            actions.applyFilter(filterData).then((data)=>{
                  const { searchData } = this.props;
                  let filterExpression = this.buildFilter(data);
                  const req = {
                        ...searchData,
                        pageNumber: 0,
                        filterExpression 
                  };

                  actions.getHotelAvailabilityXmlRequest(req);
            });
      }

      onStarRatingChange(elm) {
            const { searchFilter, actions } = this.props;
            let checkboxList = new Set(searchFilter.starRating);

            if (elm.target.checked) 
                  checkboxList.add(elm.target.name);
            else
                  checkboxList.delete(elm.target.name);

            let filterData = {...searchFilter, starRating:checkboxList};

            actions.applyFilter(filterData).then((data)=>{
                  const { searchData } = this.props;
                  let filterExpression = this.buildFilter(data);
                  const req = {
                        ...searchData,
                        pageNumber: 0,
                        filterExpression 
                  };

                  actions.getHotelAvailabilityXmlRequest(req);
            });
      }

      onDropdownChange(val, elm) {
            const { searchFilter, actions } = this.props;
            let options = Array.isArray(val) ? val.map(a=>a.label) : val;
            let expression = '';

            if (elm.action !== 'clear' && (options.length > 1 || options.label)){
                  if (elm.name === 'hotelAmenities')
                        expression =  `RatePlan.Hotel.Amenities.Where(am=> \"${options.toString()}\".split(',').ToList().Contains(am.Name)).Count() == \"${options.toString()}\".split(',').Count()`;
                  else if (elm.name === 'roomAmenities')
                        expression =  `RoomCategory.RoomAmenities.Where(am=> \"${options.toString()}\".split(',').ToList().Contains(am.Name)).Count() == \"${options.toString()}\".split(',').Count()`;
                  else if (elm.name === 'roomCategory')
                        expression =  `RoomCategory.Name == \"${options.label}\"`;
                  else if (elm.name === 'boardBasis')
                        expression =  `RatePlan.BoardBasis.Name == \"${options.label}\"`;
            }
            
            let filterData = {...searchFilter, [elm.name]:expression, [elm.name+'Value']: val};
            
            actions.applyFilter(filterData).then((data)=>{
                  const { searchData } = this.props;
                  let filterExpression = this.buildFilter(data);
                  const req = {
                        ...searchData,
                        pageNumber: 0,
                        filterExpression: filterExpression 
                  };

                  actions.getHotelAvailabilityXmlRequest(req);
            });
      }

      onRangeNumbersChange(value) {
            const { searchFilter, actions } = this.props;
            let filterData = {...searchFilter, budget:value};
            actions.applyFilter(filterData);
      }

      onBudgetChange(value) {
            const { searchFilter, actions } = this.props;
            value = {...value, changed: true};
            let filterData = {...searchFilter, budget:value};

            actions.applyFilter(filterData).then((data)=>{
                  const { searchData } = this.props;
                  let filterExpression = this.buildFilter(data);
                  const req = {
                        ...searchData,
                        pageNumber: 0,
                        filterExpression: filterExpression 
                  };

                  actions.getHotelAvailabilityXmlRequest(req);
            });
      }

      buildFilter(filterState){
            const { offers, info, starRating, boardBasis, hotelAmenities, roomAmenities, roomCategory, budget } = filterState;
            let stars = [];
            let supplement = [];
            let filters = [];

            if (budget.changed)
                  filters.push(`TotalAdultPrice + TotalChildPrice >= ${budget.min} && TotalAdultPrice + TotalChildPrice <= ${budget.max}`);

            if (offers.has('specialOffer'))
                  filters.push('(!string.IsNullOrEmpty(advancedBookingText) || !string.IsNullOrEmpty(FreeNightsText) || !string.IsNullOrEmpty(MinLengthOfStayText))');
            else {
                  if (offers.has('advancedBooking'))
                        supplement.push('!string.IsNullOrEmpty(advancedBookingText)');
                  if (offers.has('freeNights'))
                        supplement.push('!string.IsNullOrEmpty(FreeNightsText)');
                  if (offers.has('minLength'))
                        supplement.push('!string.IsNullOrEmpty(MinLengthOfStayText)');
            }
            
            if (info.has('isNonRefundable'))
                  filters.push('NonRefundable == false');
            if (info.has('webSite'))
                  filters.push('!string.IsNullOrEmpty(RatePlan.Hotel.Address.Website)');
            if (info.has('primaryPhone'))
                  filters.push('!string.IsNullOrEmpty(RatePlan.Hotel.Address.PrimaryPhone)');
            if (info.has('primaryFax'))
                  filters.push('!string.IsNullOrEmpty(RatePlan.Hotel.Address.PrimaryFax)');
            if (info.has('email'))
                  filters.push('!string.IsNullOrEmpty(RatePlan.Hotel.Address.Email)');

            if (starRating.has('1Star'))
                  stars.push('RatePlan.Hotel.StarRating.Name[0].Equals(\'1\')');
            if (starRating.has('2Stars'))
                  stars.push('RatePlan.Hotel.StarRating.Name[0].Equals(\'2\')');
            if (starRating.has('3Stars'))
                  stars.push('RatePlan.Hotel.StarRating.Name[0].Equals(\'3\')');
            if (starRating.has('4Stars'))
                  stars.push('RatePlan.Hotel.StarRating.Name[0].Equals(\'4\')');
            if (starRating.has('5Stars'))
                  stars.push('RatePlan.Hotel.StarRating.Name[0].Equals(\'5\')');
            
            if (supplement.length > 0){
                  let additional = supplement.join(' || ');
                  filters.push('('+additional+')');
            }
            if (stars.length > 0){
                  let additional = stars.join(' || ');
                  filters.push('('+additional+')');
            }

            if (boardBasis)
                  filters.push(boardBasis);
            if (hotelAmenities)
                  filters.push(hotelAmenities);
            if (roomAmenities)
                  filters.push(roomAmenities);
            if (roomCategory)
                  filters.push(roomCategory);

            return filters.join(' && ');
      }

      currencyFormat(value) {
            const currencyName = this.props.model[0]?.rates[0].currencyName;
            return new Intl.NumberFormat('en-GB', {minimumFractionDigits: 2}).format(value).replace(/\D00$/, '');
      }

      render(){
            return <FilterView 
                  {...this.props.searchFilter}
                  currencyFormat={this.currencyFormat}
                  onBudgetChange={this.onBudgetChange}
                  onRangeNumbersChange={this.onRangeNumbersChange}
                  onDropdownChange={this.onDropdownChange}
                  onInfoChange={this.onInfoChange}
                  onOffersChange={this.onOffersChange}
                  onStarRatingChange={this.onStarRatingChange}
                  isLoading={this.props.isLoading}
                  isSearchTriggered={this.props.isSearchTriggered}
                  currencyName={this.props.model[0]?.rates[0].currencyName || 'GBP'}
            />;
      }
}

function mapStateToProps(state) {
      const isLoading = state.pendingTasks > 0;
      const isFilterEmpty = !state.xml?.requestHAData?.searchFilter;
      const isSearchTriggered = !!state.xml?.requestHAData?.searchQueryId;
      return {
            model: state.xml?.data || [],
            searchData: state.xml?.requestHAData || {},
            searchId: state.xml?.requestHAData?.searchQueryId || '',
            isLoading,
            isFilterEmpty,
            isSearchTriggered,
            searchFilter: state.searchFilter,
            maxBudget: state?.xml?.maxPrice || 500
      };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchFilterContainer);